import React, { useEffect } from "react";
import { Link } from "react-router-dom";
const getYear = () => new Date().getFullYear();
export default function Header() {
    useEffect(() => {
        const handleScroll = () => {
        const scrollToTarget = document.querySelector(".scroll-to-target");
        if (window.scrollY > 50) {
            scrollToTarget?.classList.add("open");
        } else {
            scrollToTarget?.classList.remove("open");
        }
    };

        window.addEventListener("scroll", handleScroll);

        // Cleanup when component unmounts
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // Scroll-to-top click handler
    const handleScrollTop = () => {
        window.scrollTo({
        top: 0,
        behavior: "smooth",
        });
    };
    const baseUrl = import.meta.env.VITE_FRONTEND_URL;
    return(
        <>
            <footer className="footer-4 pb-5 bg-gray-900 position-relative z-1">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <Link to={baseUrl} className="logo mb-10" aria-label="Logo">
                                <img src="images/logo-white.png" alt="image" className="logo__img" />
                            </Link>
                            <p className="text-white text-opacity-75 address-footer">Our Address:
                                Office No: 201-202, Second Floor,
                                Elements Mall, DCM Ajmer Road,
                                Jaipur, 302021, Rajasthan, India <br /><br />
                                US: NO .1910, Thomes Avenue, Cheyenne, Wyoming. 82001
                                </p>
                            <h6 className="text-white mt-6 mb-4 fs-16 web-title">Around the Web</h6>
                            <div className="d-inline-flex align-items-center justify-content-center gap-2">
                                <Link target="_blank" aria-label="View Our Twitter Account" to="https://twitter.com/Infinitive_Host" className="social-icon w-9 h-9 d-grid place-content-center rounded-circle border border-light border-opacity-10 text-white text-decoration-none">
                                    <i className="fa-brands fa-x-twitter"></i>
                                </Link>
                                <Link target="_blank" aria-label="View Our Facebook Account" to="https://www.facebook.com/InfinitiveHost-435551663445191" className="social-icon w-9 h-9 d-grid place-content-center rounded-circle border border-light border-opacity-10 text-white text-decoration-none">
                                    <i className="fa-brands fa-facebook-f"></i>
                                </Link>
                                <Link target="_blank" aria-label="View Our Instagram Account" to="https://www.instagram.com/infinitive_host" className="social-icon w-9 h-9 d-grid place-content-center rounded-circle border border-light border-opacity-10 text-white text-decoration-none">
                                    <i className="fa-brands fa-instagram"></i>
                                </Link>
                                <Link target="_blank" aria-label="Join Our Whatsapp Channel" to="https://whatsapp.com/channel/0029VawJP6kKQuJNvbLl9f1U" className="social-icon w-9 h-9 d-grid place-content-center rounded-circle border border-light border-opacity-10 text-white text-decoration-none">
                                    <i className="fa-brands fa-whatsapp"></i>
                                </Link>
                                <Link target="_blank" aria-label="View Our Linkdin Account" to="https://www.linkedin.com/company/infinitivehost/" className="social-icon w-9 h-9 d-grid place-content-center rounded-circle border border-light border-opacity-10 text-white text-decoration-none">
                                    <i className="fa-brands fa-linkedin-in"></i>
                                </Link>
                            </div>
                            <div className="iso-certified mt-4">
                                <img src="images/iso-logo-w.webp" alt="" width="50px"/>
                                <p className="text-white ms-2 title">An ISO 27001 & 9001 Certified Company</p>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-6">
                            <div className="ps-xl-5">
                                <h6 className="text-white fs-16 mt-3 mb-11 web-title">Platforms</h6>
                                <ul className="list-unstyled d-flex flex-column gap-2">
                                    <li><Link to="/aws-cloud-hosting" className="footer-2-link">AWS</Link></li>
                                    <li><Link to="/google-cloud" className="footer-2-link">Google Cloud</Link></li>
                                    <li><Link to="/azure" className="footer-2-link">Azure</Link></li>
                                    <li><Link to="/kubernetes" className="footer-2-link">Kubernetes</Link></li>
                                    <li><Link to="/odoo-server" className="footer-2-link">Odoo</Link></li>
                                    <li><Link to="/vtiger-solutions" className="footer-2-link">Vtiger Solutions</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-6">
                            <div className="ps-xl-10">
                                <h6 className="text-white fs-16 mt-3 mb-11 web-title">Company</h6>
                                <ul className="list-unstyled d-flex flex-column gap-2">
                                    <li><Link to="/about-us" className="footer-2-link">About Us</Link></li>
                                    <li><Link to="/our-team" className="footer-2-link">Our Team</Link></li>
                                    <li><Link to="/work-culture" className="footer-2-link">Work Culture</Link></li>
                                    <li><Link to="/awards-and-recognitions" className="footer-2-link">Awards & Recognitions</Link></li>
                                    <li><Link to="/certificates" className="footer-2-link">Certificates</Link></li>
                                    <li><Link to="/payment-options" className="footer-2-link">Payment Options</Link></li>
                                    <li><Link to="/frequently-asked-questions" className="footer-2-link">FAQs</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-6">
                            <div className="ps-xl-5">
                                <h6 className="text-white fs-16 mt-3 mb-11 web-title">Digital Solutions</h6>
                                <ul className="list-unstyled d-flex flex-column gap-2">
                                    <li><Link to="/website-development" className="footer-2-link">Web Development</Link></li>
                                    <li><Link to="/app-development" className="footer-2-link">App Development</Link></li>
                                    <li><Link to="/digital-marketing" className="footer-2-link">Digital Marketing</Link></li>
                                </ul>
                            </div>
                            <div className="ps-xl-5">
                                <h6 className="text-white fs-16 mt-3 mb-3 web-title">Solutions</h6>
                                <ul className="list-unstyled d-flex flex-column gap-2">
                                    <li><Link to="/server-management" className="footer-2-link">Server Management</Link></li>
                                    <li><Link to="/backup-solutions" className="footer-2-link">Backup Solutions</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-6">
                            <div className="ps-xl-5">
                                <h6 className="text-white fs-16 mt-3 mb-11 web-title">Email & Security</h6>
                                <ul className="list-unstyled d-flex flex-column gap-2">
                                    <li><Link to="/office-365" className="footer-2-link">Office 365</Link></li>
                                    <li><Link to="/zimbra-mail-server" className="footer-2-link">Zimbra</Link></li>
                                    <li><Link to="/ssl-certificate" className="footer-2-link">SSL</Link></li>
                                    <li><Link to="/cyber-security" className="footer-2-link">Cyber Security</Link></li>
                                </ul>
                            </div>
                        </div>
                        
                    </div>
                    <div className="mt-20 bottom-footer">
                        <div className="d-flex align-items-center justify-content-between flex-wrap gap-5 pt-5 border-top border-light border-opacity-10">
                            <p className="text-white mb-0 fs-14">© {getYear()} Infinitive Host. All rights reserved</p>
                            <div className="d-inline-flex align-items-center justify-content-center gap-4 flex-wrap">
                                <Link to="/sitemap" className="footer-2-link">
                                    Sitemap
                                </Link>
                                <Link to="/terms-and-conditions" className="footer-2-link">
                                    Terms & Condition
                                </Link>
                                <Link to="/privacy-policy" className="footer-2-link">
                                    Privacy Policy
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

            <div className="scroll-top scroll-to-target bg-primary text-white" onClick={handleScrollTop} >
                <span><i className="fa-solid fa-angle-up"></i></span>
            </div>
        
            <Link
                to="https://wa.me/+917742553946?text=I recently check out your official website and was impressed by your web hosting solutions. I’m ready to buy a web hosting plan that matches my requirements. Could you please help me through the process?"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Chat on WhatsApp"
                className="whatsapp-float"
                >
                <i className="fa-brands fa-whatsapp"></i>
            </Link>

        
        </>
    )
}